import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tickets-ticket',
  templateUrl: './tickets-ticket.component.html',
  styleUrls: ['./tickets-ticket.component.scss']
})
export class TicketsTicketComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
